module.exports = __webpack_public_path__ + "static/media/YM28_1.12c9a1db.jpg";